import { capitalize } from 'vue';

import Colors from '@/Colors';
import i18n from '@/vueI18n';

export default class MapPointControl {
  onAdd(map) {
    this.isActive = false;
    this.mapInternal = map;
    this.containerInternal = window.document.createElement('div');
    this.containerInternal.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
    const btn = window.document.createElement('button');
    btn.className = 'mapboxgl-ctrl-icon';
    btn.title = capitalize(i18n.global.t('actions.addPointOnMap'));
    btn.onclick = () => {
      this.activate();
      if (this.clickHandler !== undefined) {
        this.clickHandler();
      }
    };
    btn.innerHTML =
      '<svg version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">\n' +
      '<path d="m79.996 29.512c0-16.301-13.402-29.512-29.93-29.512-2.0938 0-4.1328 0.21484-6.1055 0.62109-0.035157 ' +
      '0.003906-0.0625 0.011718-0.097657 0.019531-9.7383 2.0273-17.723 8.7148-21.453 17.586-0.3125 0.72656-0.57422' +
      ' 1.4766-0.82422 2.2266-0.035157 0.10156-0.078126 0.19531-0.10938 0.29297-0.94531 2.9219-1.4727 6.0273-1.4727 ' +
      '9.2617 0 14.535 10.34 26.652 24.062 29.402l1.9688 36.289c0 1.5977 1.625 4.3008 3.6406 4.3008h0.99219c2.0117 ' +
      '0 3.6445-2.6992 3.6445-4.293l2.293-36.457c13.383-3.0078 23.391-14.949 23.391-29.242 0-0.078124-0.011719-0.15234-' +
      '0.011719-0.23047 0.003906-0.09375 0.011719-0.17969 0.011719-0.26562z"/>\n' +
      '</svg>\n';
    btn.firstChild.style = 'width: 20px; height: 20px;margin-top: 4px;';
    this.btn = btn;
    this.containerInternal.appendChild(btn);
    return this.containerInternal;
  }

  onRemove() {
    this.containerInternal.parentNode.removeChild(this.containerInternal);
    this.mapInternal = undefined;
  }

  activate() {
    this.btn.firstChild.style = `width: 20px; height: 20px;margin-top: 4px; fill: ${Colors.actions};`;
  }

  deactivate() {
    this.btn.firstChild.style = 'width: 20px; height: 20px;margin-top: 4px;';
  }
}
